var _defs, _circle, _path, _path2, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Radon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SB0N3zsUc7MpX4g66qHzQa",
    x1: 15.478,
    x2: 34.518,
    y1: 0.586,
    y2: 52.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#427fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#2668cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#1358bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c52bb"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "url(#SB0N3zsUc7MpX4g66qHzQa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27,24.5V26.0031a.49676.49676,0,0,0,.3638.47432C30.666,27.44,33,29.77031,33,32.5c0,3.58984-4.02942,6.5-9,6.5s-9-2.91016-9-6.5c0-2.72969,2.334-5.06,5.63618-6.02258A.49676.49676,0,0,0,21,26.0031V24.5a.5.5,0,0,0-.5-.5H7.02946a.99166.99166,0,0,0-1.0003,1.02912,18.0003,18.0003,0,0,0,35.94168,0A.99166.99166,0,0,0,40.97054,24H27.5A.5.5,0,0,0,27,24.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.5,30a2.49694,2.49694,0,0,0-.544.06323A2.48259,2.48259,0,0,0,24,28.51129a2.48259,2.48259,0,0,0-3.956,1.55194,2.5,2.5,0,1,0,0,4.87354A2.48259,2.48259,0,0,0,24,36.48871a2.48259,2.48259,0,0,0,3.956-1.55194A2.49852,2.49852,0,1,0,28.5,30ZM24,32.51129,23.98633,32.5,24,32.48871l.01367.01129Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 21,
    r: 1,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,6A11.99751,11.99751,0,0,0,12.05,16.89737,1.0092,1.0092,0,0,0,13.05086,18h7.47729a.49445.49445,0,0,0,.49918-.40775A2.97167,2.97167,0,0,1,24.695,15.0885l3.47467-2.96582a.50126.50126,0,0,1,.70709.70715L26.19794,15.969a2.99465,2.99465,0,0,1,.77467,1.62727A.48633.48633,0,0,0,27.46218,18h7.487A1.0092,1.0092,0,0,0,35.95,16.89739,11.9975,11.9975,0,0,0,24,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Radon);
export default __webpack_public_path__ + "static/media/icons8-radon.da31a656ed2c522e59b20a6981199cb1.svg";
export { ForwardRef as ReactComponent };